/**
 * Library lazysizes
 * https://github.com/aFarkas/lazysizes
 */
window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 2;

/**
 * For use lazysize for background image you can add the attribute data-bgset="IMAGE_URL [CUSTOM_MEDIA_KEY] | IMAGE_DEFAULT_URL"
 * es: data-bgset="http://my-desktop-image-url.jpg [--md-up] | http://my-mobile-image-url.jpg"
 */
window.lazySizesConfig.customMedia = {
    '--sm-up': '(min-width: 576px)',
    '--md-up': '(min-width: 768px)',
    '--lg-up': '(min-width: 992px)',
    '--xl-up': '(min-width: 1200px)',
    '--hd-up': '(min-width: 2000px)',
    '--xl-down': '(max-width: 1999.98px)',
    '--lg-down': '(max-width: 1199.98px)',
    '--md-down': '(max-width: 991.98px)',
    '--sm-down': '(max-width: 767.98px)',
    '--xs-only': '(max-width: 577.98px)',
    '--sm-only': '(max-width: 767.98px) and (min-width: 576px)',
    '--md-only': '(max-width: 991.98px) and (min-width: 768px)',
    '--lg-only': '(max-width: 1199.98px) and (min-width: 992px)',
    '--xl-only': '(max-width: 1999.98px) and (min-width: 1200px)',
};

/**
 * Set image size style for specific element
 *
 * @param el
 */
window.setLazysizesImageStyle = (el) => {
    let imgWidth = el.getAttribute('data-width');
    let imgHeight = el.getAttribute('data-height');
    let elParentWidth = el.parentElement.clientWidth;
    let setImgHeight = (imgHeight * elParentWidth) / imgWidth;

    if (elParentWidth && imgWidth && imgHeight) {
        el.style.width = '100%';
        el.style.height = setImgHeight + 'px';
        el.style.display = 'block';
    } else if (!elParentWidth) {
        //console.warn('setLazysizesImageStyle | Not found parent width for element:');
        //console.warn(el);
        //console.warn('elParentWidth: '+elParentWidth+' - imgWidth: '+imgWidth+' - imgHeight: '+imgHeight);
    }
}

/**
 * Set image size style at all images not loaded
 */
window.preSetLazysizes = () => {
    let elements = document.querySelectorAll('[data-src].lazyload');
    [...elements].forEach(el => {
        setLazysizesImageStyle(el);
    });
}

/**
 * Set image size style before lazisize load image
 *
 * @param el
 */
document.addEventListener('lazybeforeunveil', function (e) {
    setLazysizesImageStyle(e.target);
});

/**
 * Reset image size after lazysizes loaded image
 */
document.addEventListener('lazyloaded', e => {
    let el = e.target;
    el.style.height = '';
    el.style.display = '';
});

/**
 * set placeholder for images that return 404
 */
document.addEventListener('error', function (e) {
    if (e.target.nodeName === 'IMG' && WP.routes.assets.placeholder && e.target.src !== WP.routes.assets.placeholder)
        e.target.src = WP.routes.assets.placeholder;
}, true);